/** @jsxImportSource @gasman/smush */

import { Component } from '@gasman/smush';

import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/dist/basicLightbox.min.css';

class Modal extends Component {
    constructor(content) {
        super();
        this.content = content;
    }

    render() {
        this.element = <div>{this.content}</div>;

        this.lightbox = basicLightbox.create(<div>{this.element}</div>, {
            onShow: () => {
                this.content.show();
            },
            onClose: () => {
                this.content.hide();
            },
        });
    }

    hide() {
        this.lightbox.close();
    }
    show() {
        this.lightbox.show();
    }
}

export { Modal };
